<template>
  <span>
    <v-icon
      color="blue darken-2"
      :aria-label="'actualizar carpeta ' + folder.nombre"
      @click="onClick"
      >{{ icon.pencil }}</v-icon
    >
  </span>
</template>

<script>
import { mdiPencilOutline } from '@mdi/js'
export default {
  name: 'FolderUpdate',
  props: {
    folder: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      icon: {
        pencil: mdiPencilOutline
      }
    }
  },
  methods: {
    onClick() {
      this.$emit('onClickUpdate', this.folder)
    }
  }
}
</script>
